/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_Maturity_AcInputs */

const en_pc_cmp_r_maturity_ac = /** @type {(inputs: Pc_Cmp_R_Maturity_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The industry standard for over 30 years`)
};

const zh_pc_cmp_r_maturity_ac = /** @type {(inputs: Pc_Cmp_R_Maturity_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 余年的行业标准`)
};

/**
* | output |
* | --- |
* | "The industry standard for over 30 years" |
*
* @param {Pc_Cmp_R_Maturity_AcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_maturity_ac = /** @type {((inputs?: Pc_Cmp_R_Maturity_AcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Maturity_AcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_maturity_ac(inputs)
	return zh_pc_cmp_r_maturity_ac(inputs)
});
export { pc_cmp_r_maturity_ac as "pc.cmp.r.maturity.ac" }